import { useLocation } from "react-router-dom";
import { Bell } from "lucide-react";
import { useAuthStore } from "../../store/auth.store";
import { ShopSwitcher } from "./ShopSwitcher";

const routeTitles: Record<string, string> = {
  "/dashboard": "Dashboard",
  "/analyses/new": "Yeni Analiz",
  "/mockup-studio": "Mockup Studio",
  "/listing-drafts": "Listing Taslakları",
  "/discovery": "Ürün Keşfi",
  "/tasks": "Eklenti Görevleri",
};

export function Header() {
  const location = useLocation();
  const { user } = useAuthStore();

  const title =
    routeTitles[location.pathname] ??
    (location.pathname.includes("/analyses/") ? "Analiz Detayı" : "Etsy Research Copilot");

  return (
    <header className="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6">
      <h1 className="text-lg font-semibold text-gray-900">{title}</h1>

      <div className="flex items-center gap-3">
        <ShopSwitcher />
        <button className="relative rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700">
          <Bell className="h-5 w-5" />
        </button>
        <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center text-sm font-medium text-indigo-700">
          {user?.name?.[0]?.toUpperCase() ?? "U"}
        </div>
      </div>
    </header>
  );
}
